// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"617":"a116de47","703":"c5b2648f","787":"364214df"}[chunkId] + ".chunk.js";
};